export default {"src":"/_next/static/media/column-on.df541de7.svg","height":17,"width":17};